import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/interfaces/base-entity';
import { SignalRService } from 'src/app/utils/SignalR.service';
import {
  CorpacerosUserSyncStartResponse,
  UserSyncLogsRequest,
  UserSyncLogsResponse,
} from '../models/corpaceros-user-sync.models';

@Injectable({
  providedIn: 'root'
})
export class CorpacerosUserSyncService {
  private http = inject(HttpClient);
  private signalRService = inject(SignalRService);
  private baseUrl = `${environment.host}/api/EppInventory`;

  public syncStarted$ = this.signalRService.corpacerosUserSyncStartedEvent$;
  public syncProgress$ = this.signalRService.corpacerosUserSyncProgressEvent$;
  public syncCompleted$ = this.signalRService.corpacerosUserSyncCompletedEvent$;
  public syncFailed$ = this.signalRService.corpacerosUserSyncFailedEvent$;

  /**
   * Inicia la sincronización de usuarios con Corpaceros.
   * Retorna el syncId inmediatamente (202 Accepted); el progreso llega por SignalR.
   */
  startSync(companyId: number): Observable<CorpacerosUserSyncStartResponse> {
    const url = `${this.baseUrl}/sync-corpaceros-users/${companyId}`;
    return new Observable((observer) => {
      this.http.post<{ data: CorpacerosUserSyncStartResponse }>(url, {}).subscribe({
        next: (response) => {
          observer.next(response.data);
          observer.complete();
        },
        error: (error) => observer.error(error),
      });
    });
  }

  /**
   * Consulta el historial paginado de sincronizaciones de usuarios.
   */
  getLogs(request: UserSyncLogsRequest): Observable<ApiResponse<UserSyncLogsResponse>> {
    const url = `${this.baseUrl}/sync-corpaceros-users/logs`;
    return this.http.post<ApiResponse<UserSyncLogsResponse>>(url, request);
  }
}
